import { ITemplateScope } from "AngularFormly";
import { get, set } from "lodash";
import { File } from "../../../../server/crud";
import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "../../../../utils";

export interface RecordFileTemplateOptions {
  label?: string;
  allowMultiple?: boolean;
  required?: boolean;
  uploadText?: string;
  noFilesText?: string;
  url?: string;
}

interface IRecordFileControllerScope extends ITemplateScope {
  getFiles: () => File[];
  getFileId: (file: File) => number;
  onFileUploadSuccess: (files: File[]) => void;
  remove: (file: File) => void;
}

export class RecordFileController {
  static $inject = ["$scope", RecordsUtilsServiceName];

  constructor(
    private readonly $scope: IRecordFileControllerScope,
    private readonly recordUtils: RecordsUtilsService
  ) {
    const templateOptions = <RecordFileTemplateOptions>$scope.to;
    this.initializeOptions(templateOptions);
    $scope.getFiles = () => this.getFiles();
    $scope.getFileId = (file) => this.getFileId(file);
    $scope.onFileUploadSuccess = (files) => this.onFileUploadSuccess(files);
    $scope.remove = (file) => this.remove(file);

    if (this.getFiles().length === 0 && $scope.model !== undefined) {
      set($scope.model, $scope.options.key, []);
    }

    this.assignIdsToModel(this.getFiles());
  }

  private assignIdsToModel(values: any[]): any {
    values.forEach((v) => this.recordUtils.assignId(v));
  }

  remove(file: File) {
    const files = this.getFiles();
    const index = files.indexOf(file);
    if (index < 0) return;
    files.splice(index, 1);
  }

  private onFileUploadSuccess(files: File[]): void {
    const existingFiles = this.getFiles();

    files.forEach((file) => {
      const existingFile = existingFiles.find((f) => f.Url === file.Url);
      if (existingFile) return;

      this.recordUtils.assignId(file);
      existingFiles.splice(existingFiles.length, 0, file);
    });
  }

  private getFiles(): File[] {
    return get(this.$scope.model, this.$scope.options.key) ?? [];
  }

  private getFileId(file: File): number {
    return this.recordUtils.getRecordId(file) ?? 0;
  }

  private initializeOptions(templateOptions: RecordFileTemplateOptions) {
    templateOptions.label = templateOptions.label ?? "Files";
    templateOptions.label = templateOptions.label ?? "Files";
    templateOptions.allowMultiple = templateOptions.allowMultiple ?? false;
    templateOptions.required = templateOptions.required ?? false;
    templateOptions.uploadText = templateOptions.uploadText ?? "Choose files";
    templateOptions.noFilesText = templateOptions.noFilesText ?? "No Files";
    templateOptions.url = templateOptions.url ?? "/api/files";
  }
}
